import { AuthConfig, JobStatusResponse, service } from "@theprelude/core";

const defaultPollInterval = 5000;

const sleep = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const ensureJobCompletion = async ({
  authConfig,
  jobId,
  pollInterval = defaultPollInterval,
}: {
  authConfig: AuthConfig;
  jobId: string;
  pollInterval?: number;
}): Promise<JobStatusResponse> => {
  let result = await service(authConfig).jobs.getJobStatus(jobId);
  while (!result.end_time) {
    await sleep(pollInterval);
    result = await service(authConfig).jobs.getJobStatus(jobId);
  }
  return result;
};
